import { Component, OnInit } from '@angular/core';
import { SafeHtml, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BrandingHTMLInjectorService } from '@app/shared/services/branding-htmlinjector.service';
import { AppConfigService } from '@core/services/app-config.service';
import { AuthService } from '@core/services/auth.service';
import { LocalStorageService } from '@core/services/local-storage.service';
import { Logger } from '@core/services/logger.service';

@Component({
	selector: 'cass-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

	private readonly COMPONENT_NAME = "HomeComponent";

	constructor(
		public authService: AuthService,
		public appConfigService: AppConfigService,
		private _logger: Logger,
		private _router: Router,
		private _localStorageService: LocalStorageService,
		private _brandingHtmlInjector: BrandingHTMLInjectorService)
	{
		if (authService.authStatus$.getValue().isAuthenticated) {
			if (authService.authStatus$.getValue().userOptions.isAgency) {
				_router.navigate(["dashboard"]);
			}
			else {
				_router.navigate(["myads"]);
			}
		}
	}

	ngOnInit(): void {
		this._logger.info(this.COMPONENT_NAME, "Home: starting...");
		this.injectBranding();
	}

	public brandingBelowCards?: SafeHtml;
	public brandingAboveCards?: SafeHtml;

	public createNew(): void {
		this._localStorageService.clearOrder();
		this._router.navigate(["edit"]);
	}

	private async injectBranding(): Promise<void> {
		this.brandingBelowCards = await this._brandingHtmlInjector.getInjectableHTMLFromFile('./branding/html/home-below-cards.html');
		this.brandingAboveCards = await this._brandingHtmlInjector.getInjectableHTMLFromFile('./branding/html/home-above-cards.html');
	}
}
